import __request__ from "routing/request";
export function containsStringTest(string, search_string, requestOptions) {
  return __request__("GET", "/tools/contains_string_tester", null, { "string": string, "search_string": search_string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testContainsString(JSONbody, requestOptions) {
  return __request__("POST", "/tools/contains_string_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
